import React, { useEffect } from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import { LayoutModal } from '../../templates/layout-modal/layout-modal'
import Button from '../../atoms/button/button'
import './modalSorry.scss'
import { triggerTag } from '../../../utils/taggeo'

const BG = () => (
  <div className="f-modalSorry-background">
    <div className="f-modalSorry-background__locker">
      <StaticImage
        src="../../../assets/images/modals/locker.png"
        alt="Locker de escuela"
        title="Locker de escuela"
        width={400}
        placeholder="blurred"
      />
    </div>
    <div className="f-modalSorry-background__sad">
      <StaticImage
        src="../../../assets/images/modals/sad.png"
        alt="Locker de escuela"
        title="Locker de escuela"
        width={350}
        placeholder="blurred"
      />
    </div>
    <div className="f-modalSorry-background__floor"></div>
  </div>
)

const ModalSorry = ({ close }: { close: () => void }) => {
  useEffect(()=>{
    triggerTag('12A',{
      label:'debes tener entre 9 y 19 años'
    })
  },[])
  return (
    <LayoutModal childrenBG={BG()} close={close} className="f-modalSorry">
      <>
        <h2>!Lo sentimos!</h2>
        <p>
          Para participar en esta actividad{' '}
          <span>debes tener entre 9 y 19 años.</span>
          <br />
          <br />
          Te invitamos a que ingreses a NosotrasOnline, para que disfrutes del
          resto de contenido que tenemos para ti.
        </p>
        <Button onClick={close}>Entendido</Button>
      </>
    </LayoutModal>
  )
}

export default ModalSorry
